<template>
  <div class="product-center">
    <div class="banner">
      <Banner></Banner>
    </div>
    <div class="listOne">
      <listOne></listOne>
    </div>
    <div class="big-box">
      <div class="rightfixed">
        <ul :class="searchBarFixed == true ? 'isFixed' : ''">
          <rightFixed></rightFixed>
        </ul>
      </div>      
      <div class="one-box">
          <oneBox></oneBox>
      </div>
      <div class="one">
          <oneRight></oneRight>
      </div>
      <div class="two">
        <twoBox></twoBox>
      </div>
      <div class="three">
        <threeBox></threeBox>
      </div>
      <Bottom></Bottom>
    </div>
  </div>
</template>

<script>
import Bottom from '../../components/bottom'
import Banner from "../../components/banner";
import listOne from "./components/listOne";
import oneRight from "./components/oneRight";
import oneBox from "./components/oneBox";
import twoBox from "./components/twoBox";
import threeBox from "./components/threeBox";
import rightFixed from "./components/rightFixed";
import {mapState, mapActions, mapMutations} from "vuex"
export default {
  components: {
    Banner,
    listOne,
    oneRight,
    oneBox,
    twoBox,
    threeBox,
    rightFixed,
    Bottom
  },
  computed: {
    ...mapState(["isLogin",'serviceList'])
  },
  data() {
    return {
      searchBarFixed: false,
      offsetTop: 0,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var offsetTop = document.querySelector(".rightfixed").offsetTop;
      if (scrollTop > offsetTop) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="less" scoped>
.listOne {
  width: 1920px;
  min-height: 176px;
  display: flex;
  align-items: center;
}
.big-box {
  width: 1920px;
  background: #efefef;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
  padding-top: 7px;
  .rightfixed {
    width: 90px;
    height: 230px;
    position: absolute;
    top: 350px;
    right: 10px;
    .isFixed {
      position: fixed;
      bottom: 150px;
      z-index: 999;
    }
  }
  .one,.one-box {
    width: 1510px;
    // min-height: 744px;
    margin:17px auto;
    background: #ffffff;
  }
  .one-box{
    
  }
  .two {
    width: 1510px;
    min-height: 744px;
    margin:17px auto;
    background: url("../../images/tech.jpg") no-repeat;
    background-position: center;
    background-size: contain;
  }
  .three {
    width: 1510px;
    background: #ffffff;
    margin:17px  auto;
  }
  .four {
    width: 1510px;
    min-height: 316px;
    margin:17px auto;
    background: url("../../images/four.png") no-repeat;
    background-position: center;
    background-size: contain;
  }
  .five {
    width: 805px;
    min-height: 49px;
    text-align: center;
    color: #666666;
    margin: 13px auto;
    span {
      font-size: 14px;
      color: #666666;
      line-height: 24px;
    }
  }
}
</style>